import { Injectable } from "@angular/core";

import { Extension } from "@codemirror/state";
import { autocompletion, CompletionSource } from "@codemirror/autocomplete";

import { SqlCompletionConfig } from "../models";
import { SqlEditorSchemaCompletionService } from "./sql-editor-completion-schema.service";
import { SqlEditorKeywordCompletionService } from "./sql-editor-completion-keyboard.service";


@Injectable()
export class SqlEditorCompletionService {

    constructor(private completionKeywordService: SqlEditorKeywordCompletionService,
                private completionSchemaService: SqlEditorSchemaCompletionService) {
    }

    public getCompletionExtension(config?: SqlCompletionConfig): Extension {
        const sources: CompletionSource[] = config?.sources ?? [];

        return autocompletion({
            override: [
                ...sources,
                this.completionSchemaService.getSchemaCompletionSource(config?.spec),
                this.completionKeywordService.getKeywordCompletionSource(config?.spec),
            ]
        });
    }
}